module.exports = __webpack_public_path__ + "static/img/c-info-dhl.656ced4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/carriers/c-info-dhl.png
// module id = Rt0h
// module chunks = 134